.section {
  padding: 4.5rem 0 6rem;
}

.container {
  max-width: 56rem;
  margin: 0 auto;
  padding: 0 1rem;
}

@media (min-width: 640px) {
  .container { padding: 0 1.5rem; }
}

.heading {
  margin: 0 0 2rem;
  font-size: clamp(1.65rem, 4vw, 2.25rem);
  font-weight: 740;
  letter-spacing: -0.035em;
  color: var(--zen-text-primary);
}

.tableWrap {
  overflow-x: auto;
  border-radius: 14px;
  border: 1px solid var(--zen-border);
  background: var(--zen-bg-surface);
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.tableWrap::-webkit-scrollbar {
  display: none;
}

.tableInner {
  min-width: 480px;
}

.tableHeader {
  display: grid;
  grid-template-columns: minmax(200px, 1fr) 2fr;
  border-bottom: 1px solid var(--zen-border);
  background: var(--zen-bg-elevated);
  padding: 0.75rem 1.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--zen-text-muted);
}

.tableBody {
  & > div + div {
    border-top: 1px solid var(--zen-border);
  }
}

.tableRow {
  display: grid;
  grid-template-columns: minmax(200px, 1fr) 2fr;
  padding: 0.75rem 1.25rem;
  transition: background 0.15s;
}

.tableRow:hover {
  background: color-mix(in srgb, var(--zen-bg-elevated) 50%, transparent);
}

.cmdCode {
  white-space: nowrap;
  font-size: 0.875rem;
  color: var(--zen-teal-strong);
  background: none;
  border: none;
  padding: 0;
}

@media (max-width: 600px) {
  .section { padding: 3.5rem 0 4.5rem; }
}

.cmdDesc {
  font-size: 0.875rem;
  color: var(--zen-text-secondary);
}
